import { render, staticRenderFns } from "./singlePaymentPlan.vue?vue&type=template&id=ef4d4a04&"
import script from "./singlePaymentPlan.vue?vue&type=script&lang=js&"
export * from "./singlePaymentPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports